import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  TextField,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { API } from "../constant/apiConstant";
import BackHeader from "../components/BackHeader";
import { Colors } from "../utils/colors";
import { savePendingPaystackPayment } from "../utils/pendingPaystackPayment";

export default function FundWallet() {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("paystack");

  
  const handleFund = async () => {
    if (!amount || Number(amount) < 100) {
      alert("Minimum deposit is ₦100");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API.BASE_URL}/api/payment/init`, {
        method: "POST",
        credentials: "include",
        headers: {
       "Content-Type": "application/json",
      },
      body: JSON.stringify({
      amount: Number(amount),
      type: "wallet_funding",
      payment_method: paymentMethod,
        }),
     });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.error || "Unable to initialize payment.");
      }

      if (!data?.authorization_url || !data?.reference) {
        throw new Error("Payment initialization did not return a valid redirect.");
      }

      savePendingPaystackPayment({
        reference: data.reference,
        type: "wallet_funding",
        returnPath: "/account/authmenu/account/wallets"
      });

      window.location.href = data.authorization_url;
    } catch (err) {
      console.log("Fund error:", err);
      alert(err?.message || "Unable to initialize payment.");
    }

    setLoading(false);
  };

  return (
    <Box
      sx={{
        p: 3,
        minHeight: "100vh",
        background: "linear-gradient(180deg,#001f3f,#003366,#0b2a4a)",
        color: "white",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 500 }}>
        <BackHeader title="Fund Wallet" />

        
        <Card
          sx={{
            p: 3,
            borderRadius: 2,
            background: "rgba(255,255,255,0.06)",
            backdropFilter: "blur(6px)",
            border: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          
          <Typography sx={{ mb: 1, fontWeight: 600, color:Colors.whitesmoke }}>Enter Amount</Typography>

          <TextField
            type="number"
            placeholder="₦0.00"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            fullWidth
            InputProps={{
              style: { color: "white", fontSize: 18 },
            }}
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root fieldset": {
                borderColor: "#ffa726",
              },
              "&:hover fieldset": {
                borderColor: "#ffcc80",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#ffa726",
              },
            }}
          />

          
          <Typography sx={{ mb: 1, fontWeight: 600,color:Colors.whitesmoke }}>
            Payment Method
          </Typography>

          <RadioGroup
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
          >
            <FormControlLabel
              value="paystack"
              control={<Radio sx={{ color: "#ffb300" }} />}
              label={
                <Typography sx={{ color: "white" }}>Paystack</Typography>
              }
            />
          </RadioGroup>

          
          <Button
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{
              mt: 3,
              py: 1.4,
              bgcolor: "#5fd068",
              color: "#003300",
              fontWeight: 800,
              borderRadius: 1,
              "&:hover": { bgcolor: "#4ac45a" },
            }}
            onClick={handleFund}
          >
            {loading ? <CircularProgress size={26} sx={{ color: "#003300" }} /> : "Proceed to Pay"}
          </Button>
        </Card>
      </Box>
    </Box>
  );
}
